//**-- Gradient Types --**//

const colorInfoType = Object.freeze({
  MONO: "mono",
  MULTI: "multi",
  GRADIENT: "gradient",
  CONIC_GRADIENT: "conic_gradient"
});

function getGradientStyle (type, colors, target=null) {
  let style;
  switch (type) {
    default:
    case colorInfoType.MONO:
      if (colors.length === 1) {
        style = createMonoColor(colors[0], target);
      } else {
        console.log("Mono color error or empty colors:", colors);
      }
      break;
    case colorInfoType.MULTI:
      style = createSteppedConicGradient(colors, target);
      break;
    case colorInfoType.GRADIENT:
      style = createSmoothGradient(colors, target);
      if (target) target.classList.add("color-rectangle");
      break;
    case colorInfoType.CONIC_GRADIENT:
      style = createSmoothConicGradient(colors, target);
      break;
  }
  if (!target) return style;
}

function createMonoColor (color, elementId=null) {
  if (elementId) elementId.style.background = color;
  else return `background: ${color};`;
};

/*function createSteppedConicGradient (colors, elementId=null) {
  const stepPercent = 100.0 / colors.length;
  const gradientSteps = colors.map((color, index) => {
    const start = stepPercent * index;
    const end = stepPercent * (index + 1);
    return `${color} ${start}%, ${color} ${end}%`;
  });
  const gradient = `conic-gradient(${gradientSteps.join(', ')})`;
  // apply or return
  if (elementId) elementId.style.background = gradient;
  else return `background: ${gradient}`;
};*/

function createSteppedConicGradient(colors, elementId = null) {
  const reversedColors = [...colors].reverse(); // <- inversion
  const stepPercent = 100.0 / reversedColors.length;
  const gradientSteps = reversedColors.map((color, index) => {
    const start = stepPercent * index;
    const end = stepPercent * (index + 1);
    return `${color} ${start}%, ${color} ${end}%`;
  });
  const gradient = `conic-gradient(from 0deg, ${gradientSteps.join(', ')})`; // from 0deg
  if (elementId) elementId.style.background = gradient;
  else return `background: ${gradient}`;
};

function createSmoothGradient (colors, elementId=null) {
  const gradient = `linear-gradient(to right, ${colors.join(', ')})`;
  // apply or return
  if (elementId) elementId.style.background = gradient;
  else return `background: ${gradient}`;
};

/*function createSmoothConicGradient (colors, elementId=null) {
  if (!colors || colors.length < 2) return;
  const loopedColors = [...colors, colors[0]];
  const stepPercent = 100 / (loopedColors.length - 1);
  const gradientSteps = loopedColors.map((color, index) => {
    const position = (stepPercent * index).toFixed(2);
    return `${color} ${position}%`;
  });
  const gradient = `conic-gradient(${gradientSteps.join(', ')})`;
  // apply or return
  if (elementId) elementId.style.background = gradient;
  else return `background: ${gradient}`;
};*/

function createSmoothConicGradient(colors, elementId = null) {
  if (!colors || colors.length < 2) return;
  const reversedColors = [...colors].reverse(); // <- inversion
  const loopedColors = [...reversedColors, reversedColors[0]];
  const stepPercent = 100 / (loopedColors.length - 1);
  const gradientSteps = loopedColors.map((color, index) => {
    const position = (stepPercent * index).toFixed(2);
    return `${color} ${position}%`;
  });
  const gradient = `conic-gradient(from 0deg, ${gradientSteps.join(', ')})`; // from 0deg
  if (elementId) elementId.style.background = gradient;
  else return `background: ${gradient}`;
};